module.exports = __webpack_public_path__ + "img/lois-van-baarle-petals.fdb0388.jpg";